export class Car {
  constructor(
    public model: string,
    public description: string,
    public id?:   number) {}
}
